import React, { Component } from 'react';
import ListRole from './ListRole'
import * as Business from '../../utils/business'

export default class Role extends Component {
    render() {
        return (
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <ListRole />
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/pages/Role/index.js